import { gsap } from 'gsap'
import { module } from 'modujs'
import modularLoad from 'modularload'
import shared from '../shared'
import { $body } from '../utils/dom'

export default class extends module {
  init() {
    // eslint-disable-next-line new-cap
    const load = new modularLoad({
      enterDelay: 1500,
      transitions: { customTransition: {} }
    })

    this.DOM = {
      loading: document.querySelector('.o-loading'),
      loadingSlices: document.querySelectorAll('.o-loading_slice')
    }

    this.hide = this.hide.bind(this)

    window.addEventListener('hide-loading', this.hide)

    load.on('loading', () => {
      this.show()
      this.call('stop', 'Scroll')
    })

    load.on('loaded', (
      transition,
      oldContainer,
      newContainer
    ) => {
      shared(true)

      // Update body class
      this.setNewBodyClass()
      this.hide()

      window.dispatchEvent(new Event('p-loaded'))

      this.call(
        'destroy',
        oldContainer,
        'app'
      )
      this.call(
        'update',
        newContainer,
        'app'
      )
    })
  }

  show() {
    this.call('stop', 'Scroll')
    this.DOM.loading.classList.add('-visible')

    gsap.fromTo(
      this.DOM.loadingSlices,
      { y: '100%' },
      {
        y: 0,
        duration: 1,
        ease: 'expo.inOut',
        stagger: {
          each: 0.1,
          from: 'start'
        }
      }
    )
  }

  hide(delay = 0) {
    const tl = gsap.timeline({
      delay,
      onComplete: () => {
        this.DOM.loading.classList.remove('-visible')
        this.call('start', 'Scroll')
      }
    })

    tl.fromTo(
      this.DOM.loadingSlices,
      { y: 0 },
      {
        y: '-100%',
        duration: 1,
        ease: 'expo.inOut',
        stagger: {
          each: 0.1,
          from: 'start'
        }
      }
    )

    setTimeout(() => {
      // Animate page content
      window.dispatchEvent(new Event('p-animate'))
    }, 600)
  }

  setNewBodyClass() {
    if (this.el.querySelector('[data-bodyclass]')) {
      const bodyClass = this.el.querySelector('[data-bodyclass]').getAttribute('data-bodyclass')

      $body.className = bodyClass
    }
  }

  destroy() {
    window.removeEventListener('hide-loading', this.hide)
  }
}
